module.exports = {
      id: "microphone-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#microphone",
      toString: function () {
        return this.url;
      }
    }